import chatModule from '../chatModule';

function voiceController($scope, $log, resources, eventStreamService, voiceService) {
    "ngInject";
    $scope.voiceCallId = 0;

    $scope.outConversation = function () {
        //if user not currently in call
        return !voiceService.isInCall();
    }

    $scope.inConversation = function () {
        //if user is currently in call
        return voiceService.isInCall();
    }

    $scope.isVoiceChatEligible = function () {
        //checks whether or not voice chat is enabled for user
        return $scope.chatLibrary.isVoiceChatEligible;
    }

    $scope.toggleVoiceChatLobby = function () {
        //enter voice chat lobby
        $scope.dialogLayout.details.isEnabled = !$scope.dialogLayout.details.isEnabled;
        $scope.saveIntoDialogsLayout();
    }

    $scope.init = function () {
        $scope.voiceCallId = voiceService.voiceCallId;
        //watches voiceCallId and changes call icon when needed
        const listenToVoiceCall = $scope.$watch(function () {
            return voiceService.voiceCallId;
        }, function (updatedstate, originalstate) {
            if (updatedstate !== originalstate) {
                $scope.voiceCallId = updatedstate;
            }
            });

        $scope.$on("$destroy", function () {
            if (listenToVoiceCall) {
                listenToVoiceCall();
            }
        })
    }

    $scope.init();
};

chatModule.controller("voiceController", voiceController);

export default voiceController;